/**
 * Po refreshu (reload) zawsze wróć na górę strony.
 * Czyści `#hash` z URL (np. #section-x z programu), żeby przeglądarka
 * i skrypty (OfferSubNav itd.) nie przewijały z powrotem do sekcji.
 * Pierwsze wejście z hashem (klik w link) nadal działa — tylko reload.
 */
export const resetScrollOnRefresh = () => {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const navEntry = typeof performance !== 'undefined'
    && typeof performance.getEntriesByType === 'function'
    ? performance.getEntriesByType('navigation')[0]
    : null;
  const isReload = (navEntry && navEntry.type === 'reload')
    || (typeof performance !== 'undefined'
      && performance.navigation
      && performance.navigation.type === 1);

  if (!isReload) {
    return;
  }

  const goTopAndClearHash = () => {
    if (window.location.hash) {
      const clean = `${window.location.pathname}${window.location.search}`;
      history.replaceState(history.state, '', clean);
    }
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    if (document.body) {
      document.body.scrollTop = 0;
    }
  };

  goTopAndClearHash();
  requestAnimationFrame(() => {
    goTopAndClearHash();
    requestAnimationFrame(goTopAndClearHash);
  });
  window.addEventListener('load', goTopAndClearHash, { once: true });
};

export default resetScrollOnRefresh;
